"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { useState } from "react";
import TrustpilotBadge from "./TrustpilotBadge";
import SlideBackground from "./SlideBackground";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

interface SlideData {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  backgroundImage: string;
  backgroundGradient: string;
  stats: {
    label: string;
    value: string;
  }[];
  cta: {
    primary: string;
    secondary: string;
  };
}

const slides: SlideData[] = [
  {
    id: 2,
    title: "Science-backed.",
    subtitle: "Doctor-led.",
    description:
      "Medical experts combining cutting-edge treatments with personalised nutrition plans.",
    backgroundImage: "/images/hero/4.png",
    backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
    stats: [
      { label: "Medical Experts", value: "200+" },
      { label: "MHRA Approved", value: "100%" },
      { label: "Patient Rating", value: "4.9★" },
    ],
    cta: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
  },

  {
    id: 5,
    title: "Lose weight.",
    subtitle: "Keep it off.",
    description:
      "Join 50,000+ people transforming their lives with medically-supervised weight loss programs.",
    backgroundImage:
      "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_227897902.jpeg",
    backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
    stats: [
      { label: "Medical Experts", value: "200+" },
      { label: "MHRA Approved", value: "100%" },
      { label: "Patient Rating", value: "4.9★" },
    ],
    cta: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
  },
  {
    id: 6,
    title: "Personalised care.",
    subtitle: "Real results.",
    description:
      "Tailored treatment plans designed by medical professionals for your unique weight loss journey.",
    backgroundImage:
      "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_230583986.jpeg",
    backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
    stats: [
      { label: "Medical Experts", value: "200+" },
      { label: "MHRA Approved", value: "100%" },
      { label: "Patient Rating", value: "4.9★" },
    ],
    cta: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
  },
  {
    id: 7,
    title: "Expert guidance.",
    subtitle: "Every step.",
    description:
      "Comprehensive support from certified medical professionals throughout your transformation.",
    backgroundImage:
      "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_298320945.jpeg",
    backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
    stats: [
      { label: "Medical Experts", value: "200+" },
      { label: "MHRA Approved", value: "100%" },
      { label: "Patient Rating", value: "4.9★" },
    ],
    cta: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
  },
  // {
  //   id: 8,
  //   title: "Science-backed.",
  //   subtitle: "Doctor-led.",
  //   description:
  //     "Medical experts combining cutting-edge treatments with personalised nutrition plans.",
  //   backgroundImage:
  //     "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_627161310.jpeg",
  //   backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
  //   stats: [
  //     { label: "Medical Experts", value: "200+" },
  //     { label: "MHRA Approved", value: "100%" },
  //     { label: "Patient Rating", value: "4.9★" },
  //   ],
  //   cta: {
  //     primary: "Book Consultation",
  //     secondary: "Learn More",
  //   },
  // },
  // {
  //   id: 9,
  //   title: "Science-backed.",
  //   subtitle: "Doctor-led.",
  //   description:
  //     "Medical experts combining cutting-edge treatments with personalised nutrition plans.",
  //   backgroundImage:
  //     "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_203574486.jpeg",
  //   backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
  //   stats: [
  //     { label: "Medical Experts", value: "200+" },
  //     { label: "MHRA Approved", value: "100%" },
  //     { label: "Patient Rating", value: "4.9★" },
  //   ],
  //   cta: {
  //     primary: "Book Consultation",
  //     secondary: "Learn More",
  //   },
  // },

  // {
  //   id: 1,
  //   title: "Lose weight.",
  //   subtitle: "Keep it off.",
  //   description:
  //     "Join 50,000+ people transforming their lives with medically-supervised programs.",
  //   backgroundImage: "/images/hero/1.png",
  //   backgroundGradient: "from-slate-900/60 via-purple-900/40 to-transparent",
  //   stats: [
  //     { label: "Average Weight Lost", value: "24 lbs" },
  //     { label: "Success Rate", value: "94%" },
  //     { label: "Days to Results", value: "14" },
  //   ],
  //   cta: {
  //     primary: "Start Free Assessment",
  //     secondary: "See Success Stories",
  //   },
  // },

  {
    id: 3,
    title: "Transform fast.",
    subtitle: "Stay strong.",
    description:
      "Revolutionary treatments that work 3x faster with ongoing support from day one.",
    backgroundImage: "/images/hero/3.png",
    backgroundGradient: "from-rose-900/60 via-pink-800/40 to-transparent",
    stats: [
      { label: "Faster Results", value: "3x" },
      { label: "Long-term Success", value: "89%" },
      { label: "Support Hours", value: "24/7" },
    ],
    cta: {
      primary: "Get Started Today",
      secondary: "View Programs",
    },
  },
  {
    id: 1,
    title: "Clinically proven.",
    subtitle: "Life-changing.",
    description:
      "MHRA-approved treatments delivering sustainable weight loss with continuous medical oversight.",
    backgroundImage:
      "https://clinic-digital.lon1.cdn.digitaloceanspaces.com/uk-weight-loss/hero/AdobeStock_194774555.jpeg",
    backgroundGradient: "from-emerald-900/60 via-teal-800/40 to-transparent",
    stats: [
      { label: "Medical Experts", value: "200+" },
      { label: "MHRA Approved", value: "100%" },
      { label: "Patient Rating", value: "4.9★" },
    ],
    cta: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
  },
  // {
  //   id: 4,
  //   title: "Transform fast.",
  //   subtitle: "Stay strong.",
  //   description:
  //     "Revolutionary treatments that work 3x faster with ongoing support from day one.",
  //   backgroundImage: "/images/hero/5.png",
  //   backgroundGradient: "from-rose-900/60 via-pink-800/40 to-transparent",
  //   stats: [
  //     { label: "Faster Results", value: "3x" },
  //     { label: "Long-term Success", value: "89%" },
  //     { label: "Support Hours", value: "24/7" },
  //   ],
  //   cta: {
  //     primary: "Get Started Today",
  //     secondary: "View Programs",
  //   },
  // },
];

export default function HeroSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="relative p-4 sm:p-6 lg:px-8 lg:pt-4 lg:pb-8 bg-white">
      <div className="relative h-[calc(100vh-200px)] min-h-[600px] overflow-hidden rounded-[32px]">
        {/* Sophisticated animated background particles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
          <div className="absolute -top-4 -left-4 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-[0.08] animate-pulse-premium"></div>
          <div
            className="absolute -bottom-8 -right-4 w-96 h-96 bg-cyan-400 rounded-full mix-blend-multiply filter blur-3xl opacity-[0.08] animate-pulse-premium"
            style={{ animationDelay: "2s" }}
          ></div>
          <div
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-pink-400 rounded-full mix-blend-multiply filter blur-3xl opacity-[0.06] animate-pulse-premium"
            style={{ animationDelay: "4s" }}
          ></div>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          speed={1200}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          className="h-full w-full rounded-[32px]"
        >
          {slides.map((slide, _) => (
            <SwiperSlide key={slide.id}>
              <div className="relative h-full w-full rounded-[32px] overflow-hidden">
                {/* Full coverage background */}
                <div className="absolute inset-0">
                  <SlideBackground
                    imageSrc={slide.backgroundImage}
                    fallbackText={`Background: ${slide.backgroundImage}`}
                    alt={`${slide.title} ${slide.subtitle} background`}
                  />
                  {/* Dark image overlay for reduced opacity */}
                  <div className="absolute inset-0 bg-gray-900/40 z-[5]"></div>
                </div>

                {/* Dark gradient overlay - similar to blog detail style */}
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent z-10 pointer-events-none"></div>

                {/* Additional gradient from left for text readability */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 from-0% via-gray-900/40 via-40% to-transparent to-70% z-10 pointer-events-none"></div>

                {/* Content Container */}
                <div className="relative z-30 h-full">
                  <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 2xl:px-8 h-full">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center h-full">
                      {/* Left Content - Clean content area */}
                      <div className="lg:col-span-7 xl:col-span-6 space-y-6 relative max-w-3xl">
                        {/* Main Headline */}
                        <div className="space-y-3">
                          <h1 className="text-4xl sm:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-semibold leading-[1.1] tracking-tight font-[family-name:var(--font-playfair)]">
                            <span className="block text-white mb-2">
                              {slide.title}
                            </span>
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#9d97d8] via-[#b8b3e6] to-purple-300">
                              {slide.subtitle}
                            </span>
                          </h1>
                        </div>

                        {/* Description */}
                        <p className="text-base sm:text-lg lg:text-lg xl:text-xl text-gray-200 leading-relaxed max-w-3xl font-light tracking-wide">
                          {slide.description}
                        </p>

                        {/* Stats Row */}
                        {/* <div className="flex flex-wrap gap-8 py-4">
                        {slide.stats.map((stat, statIndex) => (
                          <div key={statIndex} className="text-left group">
                            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-[#7771B8] to-purple-600 mb-1 group-hover:scale-110 transition-transform duration-300">
                              {stat.value}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600 font-semibold uppercase tracking-wide">
                              {stat.label}
                            </div>
                          </div>
                        ))}
                      </div> */}

                        {/* Premium Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 pt-2 relative z-40">
                          <a
                            href="https://ukweightloss.co.uk/consultation/GUHMJBNGE33R7CJ"
                            className="group relative bg-gradient-to-r from-[#7771B8] via-[#8f89cc] to-[#7771B8] bg-size-200 bg-pos-0 hover:bg-pos-100 text-white px-8 py-4 rounded-xl text-base sm:text-lg font-semibold shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-[1.02] overflow-hidden inline-block text-center cursor-pointer"
                          >
                            <span className="relative z-10 flex items-center justify-center gap-2">
                              {slide.cta.primary}
                            </span>
                            <div className="absolute inset-0 bg-gradient-to-r from-[#6860a3] to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                          </a>

                          <a
                            href="https://ukweightloss.co.uk/products"
                            className="group border-2 border-white/30 hover:border-white text-white px-8 py-4 rounded-xl text-base sm:text-lg font-semibold bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] shadow-lg hover:shadow-xl inline-block text-center cursor-pointer"
                          >
                            <span className="flex items-center justify-center gap-2">
                              {slide.cta.secondary}
                              <svg
                                className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>

                        {/* Refined Navigation Dots */}
                        <div className="flex space-x-3 pt-4">
                          {slides.map((_, dotIndex) => (
                            <button
                              key={dotIndex}
                              className={`h-3 rounded-full transition-all duration-500 ${
                                dotIndex === activeIndex
                                  ? "w-12 bg-gradient-to-r from-white to-gray-200 shadow-lg"
                                  : "w-3 bg-white/40 hover:bg-white/60 hover:scale-110"
                              }`}
                              aria-label={`Go to slide ${dotIndex + 1}`}
                            />
                          ))}
                        </div>
                      </div>

                      {/* Right side - Visual space for image */}
                      <div className="lg:col-span-5 xl:col-span-6 relative lg:block hidden"></div>
                    </div>
                  </div>
                </div>

                {/* Enhanced Trustpilot Badge - Aligned with content */}
                <div className="absolute bottom-20 left-0 right-0 z-25 hidden lg:block pointer-events-none">
                  <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 2xl:px-8">
                    <div className="flex justify-end pointer-events-auto">
                      <TrustpilotBadge />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
